import { render, staticRenderFns } from "./MzAutocomplete.vue?vue&type=template&id=20b2fbe8&"
import script from "./MzAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MzAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports